import React from 'react'

import { Chip } from '@Components/Chips/Chip'
import { useTranslation } from '@Globals/Translations'

export const OutOfStockChip = () => {
  const { t } = useTranslation()

  return (
    <Chip size="medium">
      {t('cms:SOLD_OUT_LABEL')}
    </Chip>
  )
}
